import styled, { keyframes } from "styled-components";

import { stylesGlobalDefault } from "../../global/globalStyle";

interface IPicture {
  size?: number;
}
export const appearFromLeft = keyframes`
  from {
    opacity: 0;
    position: absolute;
    transform: translateX(125%);
  }
  to{
    opacity: 1;
    position: relative;
    transform: translateX(0);
  }
`;

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  background-color: ${stylesGlobalDefault.white};
  justify-content: space-between;
  overflow-x: hidden;
`;

export const Logo = styled.img`
  align-self: center;
  width: 100px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  padding-right: 0px;
`;

export const HeaderPictureContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
`;

export const PictureContainer = styled.img<IPicture>`
  width: ${(props) => props.size || 48}px;
  height: ${(props) => props.size || 48}px;
  border-radius: 50%;
  cursor: pointer;
  object-fit: cover;
`;

export const styleImage = {
  width: 14,
  height: 14,
  cursor: "pointer",
};

export const avatarStyle = {
  cursor: "pointer",
};

export const Separator = styled.hr`
  width: 100%;
  margin: 24px 0;
  color: #d1dbe3;
`;

export const ContainerHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ContainerClose = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 15px;
`;

export const ContainerMenu = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleHeader = styled.span`
  font-family: ${stylesGlobalDefault.fontFamily};
  color: ${stylesGlobalDefault.titleNameColor};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  margin-top: 16px;
  margin-bottom: 8px;
`;

export const ClientName = styled.span`
  font-family: ${stylesGlobalDefault.fontFamily};
  color: ${stylesGlobalDefault.gray3};
  text-transform: uppercase;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
`;

export const Subtitle = styled.span`
  font-family: ${stylesGlobalDefault.fontFamily};
  color: ${stylesGlobalDefault.gray3};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  margin-bottom: 8px;
`;

export const Label = styled.label`
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${stylesGlobalDefault.blueDark};
`;

export const LabelLink = styled.a`
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${stylesGlobalDefault.blueDark};
  text-decoration: none;
  margin-bottom: 8px;
`;

export const TitleMenu = styled.span`
  font-family: ${stylesGlobalDefault.fontFamily};
  text-transform: uppercase;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 24px;
  color: ${stylesGlobalDefault.titleMenuColor};
`;

export const VersionContainer = styled.div`
  display: flex;
  bottom: 40px;
  font-family: ${stylesGlobalDefault.fontFamily};
  font-style: normal;
  font-weight: 700;
  flex-direction: column;
  margin-top: 16px;

  img {
    width: 100px;
    margin-bottom: 4px;
    opacity: 0.8;
  }
`;

export const customStyles = {
  content: {
    border: "none",
    backgroundColor: "rgba(35, 35, 35, -0.25)",
    inset: "auto",
    opacity: 1,
    padding: 0,
    top: 0,
    left: 0,
    borderRadius: 0,
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    zIndex: 999,
    // position: 'initial',
  },
  overlay: {
    backgroundColor: "rgba(35, 35, 35, 0.75)",
    display: "flex",
    justifyContent: "flex-end",
    zIndex: 999,
  },
};
